import { render, staticRenderFns } from "./VoucherTransfer.vue?vue&type=template&id=363c2aa9&scoped=true"
import script from "./VoucherTransfer.vue?vue&type=script&setup=true&lang=js"
export * from "./VoucherTransfer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VoucherTransfer.vue?vue&type=style&index=0&id=363c2aa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363c2aa9",
  null
  
)

export default component.exports